<template>
  <div class="patient">
    <div class="patient_head_title">请如实填写以下信息，您的详实反馈对后续诊疗非常重要。</div>
    <!-- feel -->
    <p class="content_p">
      您当下身体感觉如何？
      <span>*</span>
    </p>
    <div class="content feeling_content">
      <p
        :class="[{feel_active:item==feel_type},'feel_p']"
        v-for="(item,index) in feelArr"
        :key="index"
        @click="feel_type=item"
      >{{item}}</p>
    </div>
    <!-- Improved -->
    <p class="content_p content_p_top">已改善方面（选填）</p>
    <van-field v-model="improved_text" rows="2" autosize type="textarea" />
    <!-- noimprovement -->
    <p class="content_p content_p_top">未改善方面（选填）</p>
    <van-field v-model="noimprovement_text" rows="2" autosize type="textarea" />
    <!-- newsymptoms -->
    <p class="content_p content_p_top">新增症状（选填）</p>
    <van-field v-model="newsymptoms_text" rows="2" autosize type="textarea" />
    <!-- imgupload -->
    <p class="content_p content_p_top">请上传舌苔和舌底照片（选填）</p>
    <van-uploader
      v-model="tongueImgURL"
      multiple
      :after-read="afterRead"
      :max-count="1"
      accept="image/*"
      :preview-image="true"
      style="margin-right:12px;"
    >
      <img src="../../assets/images/followup/add_picture.png" class="pre_img" alt />
    </van-uploader>
    <van-uploader
      v-model="tongue2ImgURL"
      multiple
      :after-read="afterRead2"
      :max-count="1"
      accept="image/*"
      :preview-image="true"
    >
      <img src="../../assets/images/followup/add_picture.png" class="pre_img" alt />
    </van-uploader>
    <p class="photo_tips">示例：请在自然光下拍摄。</p>
    <p class="photo_examples">
      <img src="../../assets/images/followup/Examples1.png" alt />
      <img src="../../assets/images/followup/Examples2.png" alt />
    </p>
    <!-- inspect -->
    <p class="content_p content_p_top">本次治疗后的相关检查报告（选填）</p>
    <p class="photo_tips">请上传包含医生诊断和患者信息的诊断或检查单，方便医生更准确为您线上复诊并开具方案。</p>
    <van-uploader
      v-model="tongue3ImgURL"
      multiple
      :after-read="afterRead3"
      :max-count="1"
      accept="image/*"
      :preview-image="true"
    >
      <img src="../../assets/images/followup/add_picture.png" class="pre_img" alt />
    </van-uploader>
    <!-- evaluate1 -->
    <div class="content2 mt30">
      <p class="content2_p">本次诊疗体验</p>
      <!-- :class="[{response_:item==response_speed}]" -->
      <div class="content2_div">
        <p
          v-for="(item,index) in diagnosisArr"
          :key="index"
          @click="diagnosis_type=item,diagnosis_id=index+1"
          :class="item==diagnosis_type?'response_active response_active_'+index:''"
        >
          <span :class="'content2_img_'+index"></span>
          {{item}}
        </p>
      </div>
    </div>
    <!-- evaluate2 -->
    <div class="content2">
      <p class="content2_p">医生回复速度</p>
      <div class="content2_div">
        <p
          v-for="(item,index) in responseArr"
          :key="index"
          @click="response_type=item,response_id=index+1"
          :class="item==response_type?'response_active response_active_'+index:''"
        >
          <span :class="'content2_img_'+index"></span>
          {{item}}
        </p>
      </div>
    </div>
    <div class="sunmit_content" v-show="is_patient">
      <button class="submit" v-show="is_patient" @click="submit">提交</button>
    </div>
  </div>
</template>
<script>
import http from "../../util/uploadApiConfig";
import http2 from "../../util/iapetusApiConfig";
import md5 from "js-md5";
import { deviceType } from "../../util/deviceType";
import Vconsole from 'vconsole'
import familyBaApi from '../../util/familyBaApiConfig'
export default {
  data() {
    return {
      feelArr: [
        "痊愈",
        "基本痊愈",
        "明显好转",
        "部分好转",
        "几乎无变化",
        "未按照医嘱服药",
      ],
      feel_type: "",
      improved_text: "",
      noimprovement_text: "",
      newsymptoms_text: "",
      tongueImgURL: [],
      tongueImgPath: "",
      tongue2ImgURL: [],
      tongue2ImgPath: "",
      tongue3ImgURL: [],
      tongue3ImgPath: "",
      responseArr: ["回复迅速", "回复较快", "回复较慢", "回复很慢"],
      response_type: "",
      response_id: "",
      diagnosisArr: ["非常满意", "满意", "一般", "需要改善"],
      diagnosis_type: "",
      diagnosis_id: "",
      visit_sheet_id: 1,
      user_id: 1,
      token: "",
      is_patient: true,
      doctor_id: 0,
      archive_id: 0,
      archiveData: {},
      isApp:"",
    };
  },
  created() {
    console.log(this.$route.query)
    var listid = this.$route.query.visit_sheet_id;
    if (listid) {
      this.visit_sheet_id = listid;
    }
    var archiveid = this.$route.query.archive_id;
    if (archiveid) {
      this.archive_id = archiveid;
    }
    var doctorid = this.$route.query.doctor_id;
    if (doctorid) {
      this.doctor_id = doctorid;
    }
    let bridge = window.WebViewJavascriptBridge;
    this.isApp = this.$appUtils.isApp();
    if(this.isApp == "IOS"){
      bridge.callHandler("getUserInfo", "", (response) => {
        this.user_id = response.user_id;
        this.token = response.token;
      });
    }else  if (this.isApp == "android") {
      var user_info = this.$appUtils.appData();
      if (user_info) {
        this.user_id = user_info.user_id;
        this.token = user_info.token;
      }
    } else if (this.$route.query.is_mini) {
      this.token = this.$route.query.token
      this.doctor_id = this.$route.query.doctor_id
      this.user_id = this.$route.query.user_id
      this.platform_type ='1';
    }else if (this.$route.query.is_baoan) {
      this.token = this.$route.query.token
      this.doctor_id = this.$route.query.doctor_id
      this.user_id = this.$route.query.doctor_user_id
      this.platform_type ='1';

    }

    if (deviceType.isPatient) {
      this.is_patient = true;
    }else if(this.$route.query.is_baoan){
      this.is_patient = true;
    }else {
      this.is_patient = false;
    }

    setTimeout(()=>{
      this.getarchivesData();
    }, 1000);
  },
  methods: {
    getarchivesData() {
      let that = this;
      let url = "archives/" + this.archive_id;
      http2
        .get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: this.token,
          },
        })
        .then(function (res) {
          if (res.data.status_code == 200) {
            that.archiveData = res.data.data;
            that.$appUtils.appCloseLoadingView();
          }
        });
    },
    afterRead(file, detail) {
      //   console.log(file);
      //   console.log(file.file.name);
      //   console.log(detail);
      //   file.status = "failed";
      //   file.message = "上传失败";
      this.upload(file, detail, 1);
    },
    afterRead2(file, detail) {
      this.upload(file, detail, 2);
    },
    afterRead3(file, detail) {
      this.upload(file, detail, 3);
    },
    upload(file, detail, num) {
      //   console.log("==============" + num + "=============");
      //   console.log(file);
      //   console.log(file.file.name);
      //   console.log(detail);
      let that = this;
      let time = new Date().getTime();
      let imgname =
        md5(time + file.file.name.split(".")[0]) +
        "." +
        file.file.name.split(".")[1];
      //   console.log(imgname);
      var ossData = new FormData();
      ossData.append("work_path", "common/followup");
      ossData.append("bucket", "family-tcm");
      ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
      ossData.append("rewrite", "1");
      ossData.append("file_name", imgname);
      ossData.append("file", file.file);
      //   console.log(ossData);
      file.status = "uploading";
      file.message = "上传中...";
      http
        .post("upload", ossData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function (res) {
          console.log(res);
          if (res.data.status_code == 200) {
            let imageUrl = "common/followup/" + imgname;
            if (num == 1) {
              that.tongueImgPath = imageUrl;
            } else if (num == 2) {
              that.tongue2ImgPath = imageUrl;
            } else if (num == 3) {
              that.tongue3ImgPath = imageUrl;
            }
            file.status = "";
            file.message = "";
            // console.log(that.tongueImgPath);
            // console.log(that.tongue2ImgPath);
            // console.log(that.tongue3ImgPath);
          } else {
            file.status = "failed";
            file.message = "上传失败";
          }
        });
    },
    submit() {
      if (this.feel_type != "") {
        let params = {
          body_feeling: this.feel_type,
          archive_id: this.archive_id,
          doctor_id: this.doctor_id,
        };
        if (this.improved_text != "") {
          params["improved"] = this.improved_text;
        }
        if (this.noimprovement_text != "") {
          params["no_improve"] = this.noimprovement_text;
        }
        if (this.newsymptoms_text != "") {
          params["new_symptoms"] = this.newsymptoms_text;
        }
        if (this.tongueImgPath != "") {
          params["furred_tongue_path"] = this.tongueImgPath;
        }
        if (this.tongue2ImgPath != "") {
          params["tongue_base_path"] = this.tongue2ImgPath;
        }
        if (this.tongue3ImgPath != "") {
          params["diagnose_path"] = this.tongue3ImgPath;
        }
        if (this.response_id != "") {
          params["response_speed"] = this.response_id;
        } else {
          params["response_speed"] = 1;
        }
        if (this.diagnosis_id != "") {
          params["diagnosis_experience"] = this.diagnosis_id;
        } else {
          params["diagnosis_experience"] = 1;
        }
        // console.log(params);
        let url =
          "users/" + this.user_id + "/visit_sheets/" + this.visit_sheet_id;
        http2
          .put(url, params, {
            headers: {
              "Content-Type": "application/json",
              Authorization: this.token,
            },
          })
          .then( (res)=> {
            if (res.data.status_code == 200) {
              let bridge = window.WebViewJavascriptBridge;
              this.isApp = this.$appUtils.isApp();
              if(this.isApp == "IOS"){
                bridge.callHandler("visitSheetSubmit", {
                  visit_sheet_id: parseInt(this.visit_sheet_id),
                  user_id: parseInt(this.user_id),
                  doctor_id: parseInt(this.doctor_id),
                  name: this.archiveData.name,
                  age: this.archiveData.age,
                  sex: this.archiveData.sex,
                  body_feeling: this.feel_type
                } , response => {});
              }else  if (this.isApp == "android") {
                this.$appUtils.appVisitSheetSubmit({
                  visit_sheet_id: parseInt(this.visit_sheet_id),
                  user_id: parseInt(this.user_id),
                  doctor_id: parseInt(this.doctor_id),
                  name: this.archiveData.name,
                  age: this.archiveData.age,
                  sex: this.archiveData.sex,
                  body_feeling: this.feel_type
                });
              }else if(this.$route.query.is_baoan){
                window.location.href=familyBaApi+'/chatIM?visit_sheet_id='
                  +this.$route.query.visit_sheet_id+"&order_id="+this.$route.query.order_id+'&doctor_id='+
                  this.$route.query.doctor_id+'&doctor_user_id='+this.$route.query.doctor_user_id+'&send_follow=true'
              }
            }
          });
      } else {
        this.$dialog
          .alert({
            message: "请选择您当下身体感受",
          })
          .then(() => {
            // on close
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.patient {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 15px 75px;
  .patient_head_title {
    width: 100%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 3px 3px 12px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    font-size: 12px;
    color: #ac4b38;
    padding: 10px 0px;
    text-indent: 10px;
    margin-bottom: 20px;
  }
  .content {
    width: 100%;
    margin-bottom: 24px;
  }
  .content_p_top {
    margin-top: 24px;
  }
  .content_p {
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 20px;
    span {
      color: #ac4b38;
    }
    &::before {
      content: "";
      display: inline-block;
      width: 4px;
      height: 16px;
      margin-right: 4px;
      background: #ac4b38;
      position: relative;
      top: 3px;
      left: 0;
    }
  }
  .feeling_content {
    display: flex;
    flex-wrap: wrap;
    .feel_p {
      width: fit-content;
      padding: 5px 11px;
      background: #fff;
      color: #999999;
      box-shadow: 0px -1px 0px 0px rgba(244, 244, 244, 1);
      border-radius: 8px;
      border: 1px solid rgba(204, 204, 204, 1);
      font-size: 14px;
      margin-right: 13px;
      margin-bottom: 15px;
    }
    .feel_active {
      border: 1px solid #ac4b38;
      background: #f9f1ef;
      color: #ac4b38;
      border-radius: 8px;
      box-shadow: 0px -1px 0px 0px rgba(244, 244, 244, 1);
    }
  }
  .photo_tips {
    font-size: 14px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: rgba(102, 102, 102, 1);
    line-height: 20px;
    margin-top: 5px;
    margin-bottom: 15px;
  }
  .pre_img {
    width: 80px;
    height: 80px;
  }
  .photo_examples {
    img {
      width: 80px;
      height: 80px;
      margin-right: 12px;
    }
  }
  .content2 {
    width: 100%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 3px 3px 12px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    box-sizing: border-box;
    padding: 15px;
    margin-bottom: 10px;
    .content2_p {
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      line-height: 22px;
      margin-bottom: 20px;
    }
    .content2_div {
      width: 100%;
      display: flex;
      justify-content: space-around;
      p {
        width: fit-content;
        text-align: center;
        font-size: 12px;
        color: #999;
        span {
          display: block;
          width: 48px;
          height: 48px;
          background-size: cover;
        }
      }
      .content2_img_0 {
        background-image: url("../../assets/images/evaluate/expression1_nor.png");
      }
      .content2_img_1 {
        background-image: url("../../assets/images/evaluate/expression2_nor.png");
      }
      .content2_img_2 {
        background-image: url("../../assets/images/evaluate/expression3_nor.png");
      }
      .content2_img_3 {
        background-image: url("../../assets/images/evaluate/expression4_nor.png");
      }
      .response_active {
        color: #ac4b38;
      }
      .response_active_0 span {
        background-image: url("../../assets/images/evaluate/expression1_pre.png");
      }
      .response_active_1 span {
        background-image: url("../../assets/images/evaluate/expression2_pre.png");
      }
      .response_active_2 span {
        background-image: url("../../assets/images/evaluate/expression3_pre.png");
      }
      .response_active_3 span {
        background-image: url("../../assets/images/evaluate/expression4_pre.png");
      }
    }
  }
  .mt30 {
    margin-top: 30px;
  }
  .sunmit_content {
    width: 100%;
    padding: 8px 0px;
    // position: fixed;
    // bottom: 0px;
    // left: 0px;
    background: #fff;
    box-shadow: 0px 1px 0px 0px rgba(228, 228, 228, 1);
    border-top: 1px solid #e4e4e4;
    .submit {
      display: block;
      width: calc(100% - 40px);
      height: 48px;
      background: rgba(172, 75, 56, 1);
      border-radius: 10px;
      font-size: 18px;
      color: #fff;
      border: none;
      margin: 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/followup/patient_view.vue